import { useDashboard } from 'providers/Auth';

import { Box, Card, Collapse, Row, Table } from 'components/Blocks';
import { BookOpenIcon, ChevronRightIcon } from 'components/Blocks/Icons';

import { useToggleV2, useWindowSize } from 'hooks';

import { sortByProperty } from 'utils/array';
import { useLang } from 'locale';
import { hasNumericChars, onlyNumericChars } from 'utils/text';
import { cn } from 'styles';

export function ActivityHistory() {
  const { t } = useLang();

  const { breakpoints } = useWindowSize();

  const isMobileView = breakpoints.SMALL_TABLET;

  const [isExpanded, expandHandlers] = useToggleV2();

  const [{ completed_survey_logs }] = useDashboard();

  const history = sortByProperty(completed_survey_logs, 'completedOn', { completedOn: 'DESC' });

  const fixName = (name: string) => {
    const key = `point-history.${name}`;

    const translated = t(key);

    if (translated !== key) return translated;

    if (!hasNumericChars(name)) return name;

    const id = onlyNumericChars(name);

    return id || '-';
  };

  return (
    <Card flow="column" className="border-muted shadow-main" fullWidth>
      {isMobileView ? (
        <button className="flex select-none items-center gap-2" onClick={expandHandlers.toggle}>
          <Box className="rounded-full bg-primary/5 p-1.5 text-primary">
            <BookOpenIcon size={18} />
          </Box>

          <span className="text-sm font-semibold">{t('activity-history')}</span>

          <ChevronRightIcon
            size={20}
            className={cn('ml-auto text-primary transition-transform', isExpanded && 'rotate-90')}
          />
        </button>
      ) : (
        <Row gap="2" justifyContent="center">
          <BookOpenIcon size={20} />
          <span className="text-sm  font-semibold">{t('activity-history')}</span>
        </Row>
      )}

      <Collapse onlyRenderIfExpanded expanded={!isMobileView || isExpanded}>
        {history.length ? (
          <Table
            items={history}
            uniqueKey="name"
            cellClassName="text-center text-sm"
            headerClassName="border-b pb-1 border-b-muted"
            itemsPerPage={5}
            columns={[
              { label: `${t('Activity')}`, render: ({ name }) => fixName(name) },
              { label: `${t('reward')}`, render: ({ points }) => `${points} ${t('points')}` },
            ]}
          />
        ) : (
          <p className="text-center text-sm text-foreground-light">{t('no-history')}</p>
        )}
      </Collapse>
    </Card>
  );
}
